var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditCardGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_782_3495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 7.999V4C24.5 2.895 23.5999 2 22.4887 2H2.37534C1.26408 2 0.364014 2.895 0.364014 4V7.999H24.5Z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.364014 11V20C0.364014 21.105 1.26408 22 2.37534 22H22.4887C23.5999 22 24.5 21.105 24.5 20V11H0.364014ZM11.4263 17H4.38668V15H11.4263V17ZM20.4773 17H16.4547V15H20.4773V17Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_782_3495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.136,
    height: 24,
    fill: "white",
    transform: "translate(0.364014)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardGrey);
export default __webpack_public_path__ + "static/media/credit-card-grey.46a43aed.svg";
export { ForwardRef as ReactComponent };